<div class="modal__content filter--popup EditFeedModal">
  <div class="modal-header">
    <div>
      <h3 class="popup__title heading mb-0">Edit Feed</h3>
      <p class="popup_subTitle">Edit the feed details as needed.</p>
    </div>

    <button class="popup__close" (click)="closeModal(false)">
      <div [innerHTML]="ICONS.closeCircleIcon | safeHtml"></div>
    </button>
  </div>

  <div class="modal-body">
    <!-- Form -->
    <form [formGroup]="sportsForm">
      <!-- Form Fields Section (Two Columns) -->
      <div class="form-fields">
        <section formArrayName="sportsDetails">
          <div class="content" *ngFor="let sportGroup of sportsDetails.controls; let i = index" [formGroupName]="i">
            @if (i + 1 == selectedSport) {
              <h4>Include details for Sport {{ selectedSport }}</h4>
              <div class="form-group">
                <p class="note-text" *ngIf="sportGroup.value.Id && sportGroup.value.sportId">
                  <b>Notes:</b>
                  <span>You will not be able to edit the sports, level, media and the date. If you want to change these, please add a new feed.</span>
                </p>
                <label for="name" class="form__label">Choose your sport and showcase your skills. Ready to make your mark?*</label>

                <div class="custom-select-wrapper">
                  <ng-select
                    [searchable]="true"
                    class="form-control"
                    (search)="page = 1; _getSportList($event)"
                    [clearable]="false"
                    placeholder="Select"
                    formControlName="sportId"
                    name="region"
                    readonly
                    bindLabel="name"
                    bindValue="id"
                    [items]="sportList"
                  >
                  </ng-select>
                  <i class="bi bi-chevron-down sport-icon"></i>
                </div>
                <div *ngIf="sportGroup.get('sportId')?.hasError('required') && showError" class="invalid-feedback">*Please select a valid sport.</div>
              </div>
              @if (sportGroup.value.sportId) {
                <div class="form-group">
                  <label for="name" class="form__label">Choose level*</label>
                  <!-- <div class="custom-select-wrapper">
                    <select id="level" name="level" class="form__input form-control" formControlName="levelId" readonly>
                      <option value="" disabled>Select level</option>
                      <option *ngFor="let data of levelList" [value]="data.id">{{ data.name }}</option>
                    </select>
                    <i class="bi bi-chevron-down sport-icon"></i>
                  </div> -->
                  <div class="custom-select-wrapper">
                    <ng-select
                      class="form-control"
                      [clearable]="false"
                      placeholder="Select"
                      formControlName="levelId"
                      name="level"
                      readonly
                      bindLabel="name"
                      bindValue="id"
                      [items]="levelList"
                    >
                    </ng-select>
                    <i class="bi bi-chevron-down sport-icon"></i>
                  </div>
                  <div *ngIf="sportGroup.get('levelId')?.hasError('required') && showError" class="invalid-feedback">*Please select a level.</div>
                </div>
              }

              @if (sportGroup.value.ficorScore) {
                <div class="form-group">
                  <label class="form__label form__label__score">
                    Score: {{ sportGroup.value.ficorScore }}
                    <!-- <a href="javascript:void(0)" class="validation-error" (click)="showScoring()">Learn more about the scoring system</a> -->
                    <span class="selfScore" *ngIf="sportGroup.value.selfScore"
                      >Self Score: <b>{{ sportGroup.value.selfScore }}</b></span
                    >
                  </label>

                  <div class="slider-container">
                    <div class="slider-wrapper">
                      <input
                        type="range"
                        id="rating"
                        [style.background]="
                          'linear-gradient(to right, #433D3D 0%, #FF1300 ' +
                          percent(sportGroup.value.selfScore, sportGroup.value.ficorScore, sportGroup.value.minFicorScore) +
                          '%, #e0e0e0 ' +
                          percent(sportGroup.value.selfScore, sportGroup.value.ficorScore, sportGroup.value.minFicorScore) +
                          '%, #e0e0e0 100%)'
                        "
                        name="rating"
                        min="{{ sportGroup.value.minFicorScore }}"
                        max="{{ sportGroup.value.ficorScore }}"
                        step="1"
                        [value]="sportGroup.value.selfScore"
                        class="custom-slider"
                        readonly
                        [disabled]="true"
                      />
                      <!-- <output id="slider-value">{{sportGroup.value.selfScore || 50}}</output> -->
                    </div>
                    <div class="range-scale">
                      <span>{{ sportGroup.value.minFicorScore }}</span>
                      <span>{{ breakPoints(sportGroup.value.ficorScore, sportGroup.value.minFicorScore, 1) }}</span>
                      <span>{{ breakPoints(sportGroup.value.ficorScore, sportGroup.value.minFicorScore, 2) }}</span>
                      <span>{{ breakPoints(sportGroup.value.ficorScore, sportGroup.value.minFicorScore, 3) }}</span>
                      <span>{{ breakPoints(sportGroup.value.ficorScore, sportGroup.value.minFicorScore, 4) }}</span>
                      <span>{{ sportGroup.value.ficorScore }}</span>
                    </div>
                  </div>
                </div>
              }

              <div class="form-group">
                <label for="name" class="form__label">Date of activity*</label>
                <input
                  type="text"
                  class="datepicker date datepickericon form-control"
                  [value]="sportGroup.value.dateOfActivity ? (sportGroup.value.dateOfActivity | date: 'dd-MM-YYYY') : ''"
                  readonly
                />

                <div *ngIf="sportGroup.get('dateOfActivity')?.hasError('required') && showError" class="invalid-feedback">*Please select date.</div>
              </div>

              <div class="form-group">
                <label for="alias" class="form__label">Caption*</label>
                <div class="count">
                  <input
                    type="text"
                    appFirstLetterCaps
                    class="form__input form-control"
                    value="Experiencing cliff divingy"
                    maxlength="50"
                    formControlName="title"
                  />
                  <span class="count">{{ sportGroup.value.title?.length || 0 }}/50</span>
                </div>
                <div *ngIf="sportGroup.get('title')?.hasError('required') && showError" class="invalid-feedback">*Please enter title.</div>
                <div
                  *ngIf="!sportGroup.get('title')!.hasError('required') && showError && sportGroup.get('title')!.hasError('whitespace')"
                  class="validation-error"
                >
                  *Title cannot include only blankspace
                </div>
              </div>

              <!-- <div class="form-group">
                <label for="age" class="form__label">Describe your experience: Include dive type, difficulty, and skill level*</label>
                <div class="count">
                  <textarea appFirstLetterCaps class="form__input form-control" maxlength="300" formControlName="description"></textarea>
                  <span>{{ sportGroup.value.description?.length || 0 }}/300</span>
                </div>
                <div *ngIf="sportGroup.get('description')?.hasError('required') && showError" class="invalid-feedback">
                  Please provide a description of your experience.
                </div>
              </div> -->

              <div class="form-group">
                <label for="gender" class="form__label"
                  >Bring your skills to life by uploading videos or photos of your performance.*
                  <span class="tootltip" [ngbTooltip]="customTooltip" placement="bottom">
                    <span class="infoinput" [innerHTML]="ICONS.infoIcon | safeHtml"></span>
                  </span>

                  <ng-template #customTooltip>
                    <div class="show__tooltip">
                      <h3>Image/Video Upload Specifications for Sports Validation</h3>
                      <p><strong>File Requirements:</strong></p>

                      <h4>Video:</h4>
                      <ul>
                        <li><strong>Format:</strong> MP4, MOV, AVI</li>
                        <li><strong>Duration:</strong> 10 seconds to 3 minutes</li>
                        <li><strong>Resolution:</strong> Minimum 720p (1280x720). Recommended 1080p (1920x1080)</li>
                        <li><strong>Size Limit:</strong> Maximum 500MB per video</li>
                      </ul>

                      <h4>Image:</h4>
                      <ul>
                        <li><strong>Format:</strong> JPEG, PNG</li>
                        <li><strong>Resolution:</strong> Minimum 800x600 pixels. Recommended 1920x1080 pixels</li>
                        <li><strong>Size Limit:</strong> Maximum 10MB per image</li>
                      </ul>
                    </div>
                  </ng-template>
                </label>
                <div class="uploadImage">
                  <div class="image-upload-container">
                    <!-- <div class="image-placeholder UploadWrap" *ngIf="sportGroup.value.postMedias.length < 10">
                      <img src="../../../../../assets/images/ic_add_image.svg" />
                      <input id="fileUpload" type="file" title="" alt="" #UploadDoc (change)="onImageSelection($event, i)" />
                      <br />
                      Add image
                    </div> -->
                    <div class="uploaded-images">
                      <div *ngFor="let post of this.subItems(i).controls; let j = index">
                        <img *ngIf="post.value.mediaType == 'image'" [src]="fileDirectoriesPath + post.value.mediaUrl" alt="Image 1" />
                        <video
                          *ngIf="post.value.mediaType == 'video'"
                          poster=""
                          width="90px"
                          height="90px"
                          preload="metadata"
                          [src]="fileDirectoriesPath + post.value.mediaUrl"
                        ></video>

                        <!-- <img class="hoverVisible" (click)="removeActivity(j)" src="../../../../../assets/images/close-circle.svg" alt="cross" /> -->
                      </div>
                    </div>
                  </div>
                  <p class="rearrange-text"><img src="../../../../../assets/images/Ic_Icon-for.svg" /> Press & hold to re-arrange images</p>
                  <div *ngIf="sportGroup.value.postMedias?.length == 0 && showError" class="text-danger">*You must add at least one post.</div>
                </div>
              </div>

              <div class="form-group">
                <label class="form__label">Enter the sport's location.*</label>
                <div class="count">
                  <input type="text" class="form__input form-control" maxlength="100" placeholder="New Jersey" formControlName="location" readonly />
                  <span>{{ sportGroup.value.location?.length || 0 }}/100</span>
                </div>
                <div *ngIf="sportGroup.get('location')?.hasError('required') && showError" class="validation-error">*Please enter location.</div>
              </div>

              <button type="submit" class="common--button" (click)="onSubmit()">Update</button>
            }
          </div>
        </section>
      </div>
      <!-- Next Button -->
      <!-- <button type="submit" class="common--button_unfill common--button_unfill--height " routerLink="/profile">Previous</button> -->
      <!-- <button type="submit" class="common--button" (click)="onSubmit()">Submit</button> -->
    </form>
  </div>
</div>
